import { render } from "./InitializeBooking.vue?vue&type=template&id=3274e28b"
import script from "./InitializeBooking.vue?vue&type=script&lang=js"
export * from "./InitializeBooking.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__